import {BaseMyopMessage, Ref,} from "./BaseMessage";


export class SetAttributeMessage extends BaseMyopMessage {

    messageType = 'SetAttributeMessage';

    constructor(public ref: Ref, public name: string, public value: string) {
        super()
    }
}
